import { render, staticRenderFns } from "./EditTextTexto.vue?vue&type=template&id=66da5313&scoped=true"
import script from "./EditTextTexto.vue?vue&type=script&lang=js"
export * from "./EditTextTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66da5313",
  null
  
)

export default component.exports